import { TealText } from "@/components/standard/BFText"

export const TealifyText = ({ text }: { text: string }) => {
  if (!text) {
    return null
  }

  const textArray = text.split("|")

  return (
    <>
      {textArray.map((t, index) => {
        if (index % 2 === 0) {
          return t
        } else {
          return <TealText key={t}>{t}</TealText>
        }
      })}
    </>
  )
}
